<template>
<div class="container">
    <div class="row">
        <Button v-if="$store.state.user.userAdm || USER_TYPE_MIXIN.isBackOffice" class="mb-3" @click="handleBackHomeButton" size="small" type="outline" color="grey">
            <ArrowDropdown :rotate="90" /> Voltar
        </Button>
        <RegisterHeader />
        <BoxRegister @saveChange="saveChanges">
            <div class="col-12 d-flex justify-content-between mt-4 mb-2">
                <h4 class="c-ndarkfour regular">
                    <strong>Dados pessoais</strong> | {{ $store.state.register.partner.name | formatName }}
                </h4>
                <h6 class="c-sredfour regular">*Campos obrigatórios</h6>
            </div>
            <div class="col-12 mt-4">
                <el-form :model="partner" ref="partner" :rules="$store.state.user.userAdm || USER_TYPE_MIXIN.isBackOffice || blockInputs ? rulesAdm : rules" :class="blockInputs">
                    <div class="row">
                        <div class="col-6">
                            <el-form-item prop="name">
                                <!-- <InputText ref="name" readonly v-model="partner.name" label="Nome completo" placeholder="Martin Pereira Luz" /> -->
                                <label>Nome completo<span class="c-sredfour regular">*</span></label>
                                <el-input :class="getPrimaryColor" ref="name" v-model="partner.name" placeholder="João da Silva" :readonly="!isNewUser"/>
                            </el-form-item>
                        </div>

                        <div class="col-6">
                            <el-form-item prop="cpf">
                                <!-- <InputText v-model="partner.cpf" label="CPF" placeholder="042.725.863-76" v-mask="'###.###.###-##'"/> -->
                                <label>CPF<span class="c-sredfour regular">*</span></label>
                                <the-mask @input="validateCpfField" class="input-money" mask="###.###.###-##" v-model="partner.cpf" type="text" :masked="false" placeholder="999.999.999-99" />
                            </el-form-item>
                        </div>

                        <div class="col-6">
                            <el-form-item prop="profession">
                                <label>Qualificação do sócio<span class="c-sredfour regular">*</span></label>
                                    <el-select v-model="partner.profession" clearable filterable placeholder="Sócio">
                                    <el-option
                                        v-for="qualification in partnerQualificationList"
                                        :key="qualification.code"
                                        :label="`${qualification.code} - ${qualification.description}`"
                                        :value="qualification.description"
                                    >
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </div>

                        <div class="col-12 mt-3">
                            <el-form-item prop="sex">
                                <!-- <InputRadio v-model="partner.sex" label="Sexo" :items="['Feminino', 'Masculino']" /> -->
                                <label>Sexo<span class="c-sredfour regular">*</span></label>
                                <el-radio :class="getPrimaryColor" @change="validateSexField" v-model="partner.sex" label="F">Feminino</el-radio>
                                <el-radio :class="getPrimaryColor" @change="validateSexField" v-model="partner.sex" label="M">Masculino</el-radio>
                            </el-form-item>
                        </div>

                        <div class="col-6">
                            <el-form-item prop="rg">
                                <label>RG/RNE<span class="c-sredfour regular">*</span></label>
                                <InputText v-model="partner.rg" label="" placeholder="99.999.999-9" />
                            </el-form-item>
                        </div>

                        <div class="col-3">
                            <el-form-item prop="rgEmissionDate">
                                <!-- <InputText v-model="partner.rgEmissionDate" label="RG" placeholder="38.945.943-0" /> -->
                                <label>Data de emissão</label>
                                <!-- <el-input :class="getPrimaryColor" type="date" v-model="partner.birthdate" placeholder="28/07/1999" /> -->
                                <el-date-picker :clearable="false" v-model="partner.rgEmissionDate" type="date" placeholder="DD/MM/YYYY" format="dd/MM/yyyy" value-format="yyyy-MM-dd" v-mask="'##/##/####'" placement="top"/>
                            </el-form-item>
                        </div>

                        <div class="col-3">
                            <el-form-item prop="rgIssuer">
                                <InputText v-model="partner.rgIssuer" label="Órgão emissor" placeholder="SSP-SP" />
                            </el-form-item>
                        </div>

                        <div class="col-6 mt-2">
                            <el-form-item prop="birthdate">
                                <!-- <InputText v-model="partner.birthdate" label="Data de nascimento" placeholder="28/07/1999" v-mask="'##/##/####'"/> -->
                                <label>Data de nascimento</label>
                                <!-- <el-input :class="getPrimaryColor" type="date" v-model="partner.birthdate" placeholder="28/07/1999" /> -->
                                <el-date-picker :clearable="false" v-model="partner.birthdate" type="date" placeholder="DD/MM/YYYY" format="dd/MM/yyyy" value-format="yyyy-MM-dd" v-mask="'##/##/####'" placement="top"/>
                                <!-- <el-date-picker :clearable="false" class="overflow-hidden" v-model="partner.birthdate" type="date" placeholder="DD/MM/YYYY" format="dd/MM/yyyy" value-format="yyyy-MM-dd" v-mask="'##/##/####'" placement="top" :picker-options="pickerOptions" /> -->
                            </el-form-item>
                        </div>

                        <div class="col-6 mt-2">
                            <el-form-item prop="birthState">
                                <Select :items="statesOptions" v-model="partner.rgEmissionState" label="Estado onde foi emitido " placeholder="São Paulo" />
                            </el-form-item>
                        </div>

                        <div class="col-6 mt-2">
                            <el-form-item prop="nationality">
                                <InputText v-model="partner.nationality" label="Nacionalidade" placeholder="Brasileiro(a)" />
                            </el-form-item>
                        </div>

                        <!-- <div class="col-6 mt-2">
                            <el-form-item prop="birthState">
                                <Select :items="statesOptions" v-model="partner.birthState" label="Estado" placeholder="SP" />
                            </el-form-item>
                        </div> -->

                        <div class="col-6 mt-2">
                            <el-form-item prop="birthplace">
                                <InputText v-model="partner.birthplace" label="Naturalidade" placeholder="São Paulo (SP)" />
                            </el-form-item>
                        </div>


                    </div>

                    <div class="row mt-5">
                        <div class="col-12  mb-3">
                            <p class="c-ndarkfour medium">
                                Contato
                            </p>
                        </div>
                        <div class="col-6">
                            <el-form-item prop="email">
                                <label>E-mail<span class="c-sredfour regular">*</span></label>
                                <InputText type="email" v-model="partner.email" label="" placeholder="email@dominio.com" />
                            </el-form-item>
                        </div>

                                <div class="col-6">
                                    <el-form-item prop="phoneNumber">
                                        <!-- <InputText v-model="partner.phoneNumber" label="Telefone residencial" placeholder="(11) 3456-5555" v-mask="'(##) ####-####'" /> -->
                                        <label>Telefone<span class="c-sredfour regular">*</span></label>
                                        <the-mask @input="validatePhoneField" class="input-money" :mask="['(##) ####-####','(##) #####-####']" v-model="partner.phoneNumber" type="text" :masked="false" placeholder="(99) 9999-9999" />
                                    </el-form-item>
                                </div>

                                <!-- <div class="col-6">
                                    <el-form-item prop="mobileNumber">
                                        <label>Telefone celular</label>
                                        <the-mask class="input-money" :mask="['(##) ####-####','(##) #####-####']" v-model="partner.mobileNumber" type="text" :masked="false" placeholder="(11) 94657-4567" />
                                    </el-form-item>
                                </div> -->
                        <div class="col-12 mt-4">

                            <div class="row">


                            </div>

                        </div>

                    </div>

                    <div class="row mt-4">
                        <div class="col-12 mb-3">
                            <p class="c-ndarkfour medium">
                                Informações adicionais
                            </p>
                        </div>

                        <div class="col-6">
                            <el-form-item prop="eCpf">
                                <!-- <InputRadio v-model="partner.eCpf" label="Esta empresa possui E-CPF?" :items="['Não', 'Sim']" /> -->
                                <h6 class="c-ndarkfour regular">
                                    Este sócio possui e-CPF?<span class="c-sredfour regular">*</span>
                                    <!--
                                        <el-tooltip placement="bottom" class="ml-1">
                                            <template slot="content">
                                                É necessário que os representantes tenham E-CPF, um certificado digital que os<br>
                                                identificam no meio eletrônico e permitem que assinem documentos digitalmente<br>
                                                com validade jurídica. Isso só será exigido no momento do aceite das propostas<br>
                                                na plataforma. Caso não tenha, a {{ getWhiteLabel | capitalizeFirstLetter }} tem um acordo com uma empresa<br>
                                                do Serasa Experian que realiza esse processo. 
                                            </template>
                                            <Question color="#A1A8B8" />
                                        </el-tooltip>
                                    -->
                                </h6>
                                <el-radio :class="getPrimaryColor" @change="validateECpfField" v-model="partner.eCpf" :label="1">Sim</el-radio>
                                <el-radio :class="getPrimaryColor" @change="validateECpfField" v-model="partner.eCpf" :label="0">Não</el-radio>
                            </el-form-item>
                        </div>

                        <div class="col-6">
                            <el-form-item prop="currentlyMarried">
                                <h6 class="c-ndarkfour regular">Este sócio está atualmente casado?<span class="c-sredfour regular">*</span></h6>
                                <el-radio :class="getPrimaryColor" v-model="partner.currentlyMarried" :label="1">Sim</el-radio>
                                <el-radio :class="getPrimaryColor" v-model="partner.currentlyMarried" :label="0">Não</el-radio>
                            </el-form-item>
                        </div>

                        <div class="col-6">
                            <el-form-item prop="registrationStatus" v-if="$store.state.user.userAdm || USER_TYPE_MIXIN.isBackOffice">
                                <h6 class="c-ndarkfour regular">Mostrar na situação cadastral do sócio?</h6>
                                <el-radio :class="getPrimaryColor" v-model="partner.registrationStatus" :label="1">Sim</el-radio>
                                <el-radio :class="getPrimaryColor" v-model="partner.registrationStatus" :label="0">Não</el-radio>
                            </el-form-item>
                        </div>

                        <div class="col-6">
                            <el-form-item prop="registerComplete" v-if="$store.state.user.userAdm || USER_TYPE_MIXIN.isBackOffice">
                                <h6 class="c-ndarkfour regular">Possui cadastro completo?</h6>
                                <el-radio :class="getPrimaryColor" v-model="partner.registerComplete" :label="1">Sim</el-radio>
                                <el-radio :class="getPrimaryColor" v-model="partner.registerComplete" :label="0">Não</el-radio>
                            </el-form-item>
                        </div>

                    </div>
                    
                </el-form>

                <div class="row my-5">
                    <RegisterNavigationButtons
                        v-if="($store.state.user.userAdm || USER_TYPE_MIXIN.isBackOffice) && !isNewUser"
                        @backStep="backStep"
                        @nextStep="nextStep"
                        @saveChange="validateForm"
                    />
                    <div class="col-12 d-flex align-items-center" v-else>
                        <Button @click="handleBackButton" class="mr-4 px-3" type="outline" :color="getPrimaryColor">
                            <ArrowDropdown :rotate="90" :color="getPrimaryColorHex.four"/>
                            Voltar
                        </Button>
                        <Button v-if="!blockInputs" @click="validateForm" :color="getPrimaryColor"> Salvar e continuar </Button>
                        <Button v-else @click="nextStep" :color="getPrimaryColor"> Continuar </Button>
                    </div>
                </div>

            </div>
        </BoxRegister>
    </div>
    <CancelRegister :dialogVisible="dialogVisible" @closeModal="dialogVisible = $event" @cancelRegister="backStep" @saveChange="validateForm"/>
    <!--
        <SerasaExperianRegister :isCPF="true" :dialogVisible="serasaExperianDialogVisible" @closeModal="serasaExperianDialogVisible = $event" @sendEmail="sendEmail" />
        <SerasaExperianEmail :isCPF="true" :dialogVisible="serasaExperianEmailVisible" @closeModal="serasaExperianEmailVisible = $event" />
    -->
</div>
</template>

<script>
//import CompanyTypeStatus from '@/components/status/CompanyTypeStatus'
import CancelRegister from '@/components/modals/CancelRegister'
//import SerasaExperianRegister from '@/components/modals/SerasaExperianRegister'
//import SerasaExperianEmail from '@/components/modals/SerasaExperianEmail'
import ArrowDropdown from '@/components/icons/ArrowDropdown'
//import Question from '@/components/icons/Question'
import BoxRegister from '@/components/box/BoxRegister'
import brazilianStatesNameList from '@/utils/brazilianStatesNameList'
import partnerQualificationList from '@/utils/partnerQualificationList'
import updatePartnerPF from '@/api/updatePartnerPF'
import insertPartner from '@/api/insertPartner'
//import sendSerasaExperianEmail from '@/api/sendSerasaExperianEmail'
//import getUserData from '@/api/getUserData'
import removeMask from '@/utils/removeMask'
import RegisterHeader from '@/components/register/RegisterHeader'
import statusCodesBlockInput from '@/utils/statusCodesBlockInput'
import RegisterNavigationButtons from '@/components/register/RegisterNavigationButtons'
import Vue from 'vue'

import _ from 'lodash'


export default {
    components: {
        //CompanyTypeStatus,
        CancelRegister,
        //SerasaExperianRegister,
        //SerasaExperianEmail,
        ArrowDropdown,
        //Question,
        BoxRegister,
        RegisterHeader,
        RegisterNavigationButtons
    },
    data() {
        return {
            backToCompanyHome: false,
            dialogVisible:false,
            //serasaExperianDialogVisible: false,
            //serasaExperianEmailVisible: false,
            partner: {
                name: '',
                cpf: '',
                sex: '',
                birthdate: '',
                rg: '',
                rgEmissionDate: '',
                rgIssuer: '',
                nationality: '',
                birthplace: '',
                birthState: '',
                email: '',
                phoneNumber: '',
                mobileNumber: '',
                eCpf: '',
                registrationStatus: '',
                profession: ''
            },
            partnerQualificationList,
            registrationForm: [],
            documents: [],
            statesOptions: [],
            rulesAdm: {
                name: [
                    {
                        required: true,
                        message: 'Por favor, insira o nome',
                        trigger: 'blur'
                    }
                ],
                cpf: [
                    {
                        required: true,
                        message: 'Por favor, insira o CPF',
                        trigger: 'blur'
                    },
                    {
                        min: 11,
                        message: 'O CPF deve ter no mínimo 11 caracteres',
                        trigger: 'change'
                    }
                ],
                rg: [
                    {
                        pattern: /^[0-9]*?[-.]*?[0-9]*?[-.]*?[0-9]*?[-.]?[0-9]+$/,
                        message: 'Por favor, insira apenas números',
                        trigger: 'blur'
                    },
                ],
                profession:[
                    {
                        required: true,
                        message: 'Por favor, selecione a qualificação do sócio',
                        trigger: 'blur'
                    },
                    {
                        min: 1,
                        message: 'Por favor, selecione a qualificação do sócio',
                        trigger: 'change'
                    }
                ],
            },
            rules: {
                name: [
                    {
                        required: true,
                        message: 'Por favor, insira o nome',
                        trigger: 'blur'
                    },
                ],
                email: [
                    {
                        required: true,
                        message: 'Por favor, insira o e-mail',
                        trigger: 'blur'
                    },
                    {
                        type: 'email',
                        message: 'Por favor, insira um e-mail válido',
                        trigger: 'change'
                    },
                ],
                cpf: [
                    {
                        required: true,
                        message: 'Por favor, insira o CPF',
                        trigger: 'blur'
                    },
                    {
                        min: 11,
                        message: 'O CPF deve ter no mínimo 11 caracteres',
                        trigger: 'change'
                    }
                ],
                rg: [
                    {
                        required: true,
                        message: 'Por favor, insira o RG/RNE',
                        trigger: 'blur'
                    },
                ],
                phoneNumber:[
                    {
                        required: true,
                        message: 'Por favor, insira um número de telefone',
                        trigger: 'blur'
                    },
                    {
                        min: 10,
                        message: 'Por favor, insira um número de telefone válido',
                        trigger: 'change'
                    }
                ],
                profession:[
                    {
                        required: true,
                        message: 'Por favor, selecione a qualificação do sócio',
                        trigger: 'blur'
                    },
                    {
                        min: 1,
                        message: 'Por favor, selecione a qualificação do sócio',
                        trigger: 'change'
                    }
                ],
                eCpf:[{
                    required: true,
                    message: 'Por favor, selecione uma opção',
                    trigger: 'change'
                }],
                currentlyMarried:[{
                    required: true,
                    message: 'Por favor, selecione uma opção',
                    trigger: 'change'
                }],
                sex:[{
                    required: true,
                    message: 'Por favor, selecione uma opção',
                    trigger: 'change'
                }],
            },
            formValid: false,
        }
    },
    watch: {
        partner: {
            deep: true,
            handler() {
                if (!this.$store.state.register.formIsChanged) {
                    this.$store.commit('register/setFormIsChanged', true)

                }                
            }
        },
    },
    computed: {
        routePrefix() {
            return (this.$store.state.user.userAdm || this.USER_TYPE_MIXIN.isBackOffice) ? `/partner/${this.$route.params.idCNPJ}` : `/company/register/${this.$route.params.idCNPJ}/partner`
        },
        blockInputs() {
            return (!this.$store.state.user.userAdm && !this.USER_TYPE_MIXIN.isBackOffice) &&  statusCodesBlockInput.includes(this.$store.state.register.company.cnpj.registerComplete) ? 'input-block' : ''
        },
        isNewUser() {
            return this.$route.path.includes('new')
        }
    },
    methods: {
        validateForm() {
            this.$refs['partner'].validate((valid) => {
                if (valid) {
                    this.saveChanges()
                } else {
                    this.$notify({
                        title: 'Por favor, preencha todos os campos!',
                        message: '',
                        type: 'error',
                        duration: 3000,
                        offset: 100,
                        showClose: false,
                        customClass: 'error'
                    });
                }
            });
        },
        validateCpfField() {
            if (this.$refs['partner']) this.$refs['partner'].validateField('cpf')
        },
        validatePhoneField() {
            if (this.$refs['partner']) this.$refs['partner'].validateField('phoneNumber')
        },
        validateECpfField() {
            this.$refs['partner'].validateField('eCpf')
            //    if (!this.partner.eCpf && !this.$store.state.register.serasaExperianInvite && !this.$store.state.user.userAdm && !this.USER_TYPE_MIXIN.isBackOffice) {
            //        this.$store.commit('register/setSerasaExperianInvite', true)
            //        return this.serasaExperianDialogVisible = true
            //    }
        },
        validateSexField() {
            this.$refs['partner'].validateField('sex')
        },
        handleCloseModal() {
            this.dialogVisible = false
            this.backToCompanyHome = false
        },
        handleBackButton() {
            if (this.$store.state.register.formIsChanged) {
                this.dialogVisible = true
            } else {
                this.backStep()
            }
        },
        handleBackHomeButton() {
            this.backToCompanyHome = true
            if (this.$store.state.register.formIsChanged) {
                this.dialogVisible = true
            } else {
                this.backStep()
            }
        },
        nextStep() {
            this.isNewUser
                ? this.$router.push(`${this.routePrefix}/pf/${this.$store.state.register.partner.id}/1?new=true`)
                : this.$router.push(`${this.routePrefix}/pf/${this.$route.params.id}/1`)
        },
        backStep() {
            const companyType = this.$store.state.register.company.cnpj.companyType
            const route = this.backToCompanyHome ? `/company/${this.USER_TYPES_MIXIN[companyType] ||''}` : `${this.routePrefix}`
            this.$router.push(route)
        },
        async saveChanges() {
            const unmaskedPartner = _.pickBy({
                ...this.partner,
                cpf: removeMask(this.partner.cpf),
                phoneNumber: removeMask(this.partner.phoneNumber),
                mobileNumber: removeMask(this.partner.mobileNumber),
                cnpjId: this.$route.params.idCNPJ
            }, (value) => value !== null && value !== undefined);

            const result = this.isNewUser
                ? await insertPartner(unmaskedPartner)
                : await updatePartnerPF(this.$route.params.id, unmaskedPartner)

            if (result.ok) {
                this.$notify({
                    title: 'Dados salvos com sucesso.',
                    message: '',
                    type: 'success',
                    duration: 3000,
                    offset: 100,
                    showClose: false,
                })
                this.$store.commit('register/setPartner', { ...this.partner, id: result.payload.id })
                this.$store.commit('register/setFormIsChanged', false)
                if ((!this.$store.state.user.userAdm && !this.USER_TYPE_MIXIN.isBackOffice) || this.isNewUser) this.nextStep()
            }
        },
        //async sendEmail() {
        //    this.serasaExperianDialogVisible = false
        //
        //    if (!this.$store.state.user.infos.name || !this.$store.state.user.infos.email || !this.$store.state.user.infos.phoneNumber) {
        //        await getUserData(this.$store.state.user.token)
        //    }
        //
        //    const response = await sendSerasaExperianEmail({
        //        isCPF: true,
        //        companyName: this.$store.state.register.company.name,
        //        companyCnpj: this.$store.state.register.company.cnpj.cnpj,
        //        responsibleName: this.$store.state.user.infos.name,
        //        responsibleEmail: this.$store.state.user.infos.email,
        //        responsiblePhone: this.$store.state.user.infos.phoneNumber
        //    })
        //
        //    if (response.ok) {
        //        this.serasaExperianEmailVisible = true
        //    } else {
        //        this.$notify({
        //            title: 'Ops, algo deu errado! O e-mail não foi enviado.',
        //            message: '',
        //            type: 'error',
        //            duration: 3000,
        //            offset: 100,
        //            showClose: false,
        //            customClass: 'error'
        //        });
        //    }
        //}
    },
    created() {
        /* this.partner = this.$store.state.register.partners.find(partner => (partner.id == this.$route.params.id && partner.associateType == 'Sócio' )) */
        this.partner = this.$store.state.register.partner
        this.statesOptions = brazilianStatesNameList
        this.formValid = true
        this.$store.commit('register/setFormIsChanged', false)
    },
    mounted() {
        Vue.nextTick(() => {
            this.$store.commit('register/setFormIsChanged', false)
        })
    }

}
</script>

<style lang="scss" scoped>

</style>
